<script setup>
import { ref, computed, onUnmounted } from 'vue';
import { useSidebarStore } from '@components/Sidebar/stores/sidebar-store.js';
import SkeletonRenderer from './SkeletonRenderer.vue';

import { useDashboardStore } from '@/stores/dashboard-store.js';
import Vue from 'vue';

const sidebarStore = useSidebarStore();
const { openRightSidebar } = sidebarStore;
const dashboardStore = useDashboardStore();
const agParams = ref(null);
let loadTimeout = null;

const workflowsWithStatus = computed(() => {
  const id = agParams.value?.data?.id;
  return dashboardStore.workflowStatusCache[id] || [];
});

const showSkeleton = computed(() => {
  return dashboardStore.showQuickLinksSkeleton;
});

const hasWorkflow = computed(() => {
  return workflowsWithStatus.value.length > 0;
});

const loadIfNeeded = async () => {
  const data = agParams.value?.data;
  if (!data?.has_approval) return;
  if (dashboardStore.workflowStatusCache[data.id] || dashboardStore.workflowStatusLoading.has(data.id)) {
    return;
  }
  dashboardStore.workflowStatusLoading.add(data.id);

  try {
    console.log(`[wf status fetch] start: ${data.id}`);
    const res = await Vue.prototype.$harbourData.post('data?workflows-getapprovalstatus', {
      requesttype: 'workflows-getapprovalstatus',
      displayid: data.id,
    });
    if (res.data?.state === 'SUCCESS') {
      console.log(`[wf status fetch] success: ${data.id}`);
      dashboardStore.workflowStatusCache[data.id] = res.data.workflows_status || [];
      const rowNode = dashboardStore.gridApi?.getRowNode(data.id);
      if (rowNode) {
        rowNode.data.workflows_status = dashboardStore.workflowStatusCache[data.id];
        dashboardStore.gridApi?.redrawRows({ rowNodes: [rowNode] });
      }
    }
  } catch (e) {
    console.error(`[wf status fetch] error: ${data.id}`, e);
  } finally {
    dashboardStore.workflowStatusLoading.delete(data.id);
  }
};

const init = (params) => {
  agParams.value = params;
  loadIfNeeded();
}

onUnmounted(() => {
  if (loadTimeout) {
    clearTimeout(loadTimeout);
    loadTimeout = null;
  }
});

</script>

<template>
  <div
    :ref="init(params)"
    @click="openRightSidebar"
  >
    <!-- Show skeleton while loading -->
    <SkeletonRenderer v-if="showSkeleton" class="skeleton-renderer" />


    <!-- Show actual workflow content -->
    <div v-else>
      <div v-for="wf in workflowsWithStatus" :key="wf.id">
        <div v-if="hasWorkflow" class="wf-status wf-row">
          <i class="fal fa-code-branch"></i>
          <div class="wf-info">
            <div class="wf-name">{{ wf.wf_name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.wf-name {
  font-weight: 500;
  color: #999;
  font-size: 12px;
  line-height: 1em;
}
.wf-status {
  font-weight: 500;
  color: #666;
}
.wf-info {
  display: flex;
  flex-direction: column;
}
.wf-row {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 10px;
}
.wf-row i {
  margin-right: 10px;
  font-weight: 600;
}
.skeleton-renderer {
  width: 150px !important;
}
</style>
